type WantColumnTitleProps = {
  children: string;
};

export default function WantColumnTitle({ children }: WantColumnTitleProps) {
  return <div className='text-xl font-semibold text-gray-800'>{children}</div>;
}
